import React from "react";
import RealTimeVisibility from "../../../images/dtn-network-icons/real-time-visibility.svg";
import ImprovedQuality from "../../../images/dtn-network-icons/improved-quality.svg";
import Traceability from "../../../images/manufacturerBenefits/search.svg";
import { Row, Col } from "react-bootstrap";
import BenefitsCard from "../../BenefitsCard/BenefitsCard";
import { Container } from "@material-ui/core";
import Icon1 from "../../../images/gbrFarmerBenefits/pay-per-click.svg";
import Icon2 from "../../../images/gbrFarmerBenefits/economic-growth.svg";

export default function PPNBenefits() {
  const benefits = [

   
     
    {
      img: RealTimeVisibility,
      title: "Real Time Visibility",
      bodycopy:
      " Real-time visibility is a core benefit of PPN Network, offering users immediate access to crucial data and insights across manufacturing operations, enabling informed decisions and maximizing efficiency.",
    },
    {
        img: Traceability,
        title: "Traceability",
        bodycopy: " Traceability is a distinct advantage of PPN Network, ensuring transparent tracking of products throughout the supply chain, enhancing accountability and quality assurance for consumers and producers alike."    },
     
        {
          img: ImprovedQuality,
          title: "Improve Quality Production",
          bodycopy: "Enhanced quality production is a key benefit of PPN Network, utilizing data-driven insights and advanced tech to optimize production processes, yielding superior results."    },
          {
            img: Icon1,
            title: "Monetize unutilized capacity ",
            bodycopy:
              "Monetizing unutilized capacity allows businesses to boost earnings by efficiently using their operational capabilities, unlocking additional revenue streams and improving overall profitability. "
          },
          {
            img: Icon2,
            title: "Improve Top line",
            bodycopy:
              "Experience exponential growth as sales revenue soars to new heights, unlocking unprecedented success for your business. "
          },
  ];
  return (
    <div className="main-wrapper">
          <Container className="subSectionWrapper ">
      <h2 className="text-center container-title mb-4">
          Benefits
      </h2>
      <Row>
        {benefits.map((e,index) => {
          return (
            <Col key={index} md={4} className="d-flex">
              <BenefitsCard src={e.img} title={e.title} bodycopy={e.bodycopy} />
            </Col>
          );
        })}
      </Row>
      </Container>
    </div>
  );
}
